import {useCallback, useEffect, useMemo, useState} from 'react'
import {useForm} from 'react-hook-form'
import {useParams} from 'react-router-dom'
import analyticsService from 'services/analytic'
import {removeUserPrefixes} from 'services/utils/apiUtils'
import {
    useDeleteClientMutation,
    useGetClientsQuery,
    useSaveClientMutation,
} from 'store/Store'

const useClientScreen = () => {
    const {clientId} = useParams()
    const [editMode, setEditMode] = useState(false)
    const [errorMessage, setErrorMessage] = useState(null)

    const [doSaveClient, {error: saveClientError}] = useSaveClientMutation()
    const {data: clients} = useGetClientsQuery()
    const [doDelete] = useDeleteClientMutation()

    // console.log('client screen', {clientId, clients})

    const displayClient = useMemo(() => {
        const client = clients?.find(
            (client) => client.PlannerClientKey.toString() === clientId
        )

        console.log('clients', clients)

        if (!client) {
            return null
        }
        return {
            ...client,
            CleanClientPhone: removeUserPrefixes(client?.AccountKey)(
                client?.ClientPhone
            ),
            CleanClientId: removeUserPrefixes(client?.AccountKey)(
                client?.ClientId
            ),
        }
    }, [clientId, clients])

    const methods = useForm({
        defaultValues: displayClient,
    })

    const {handleSubmit, reset} = methods

    const toggleEdit = () => {
        refresh()
        setEditMode(!editMode)
        analyticsService.existingClientPressed(
            editMode ? 'edit_client' : 'edit_and_cancel'
        )
    }

    const onSubmit = async (values) => {
        doSaveClient(values)
        toggleEdit()
        analyticsService.existingClientPressed('edit_and_save')
    }

    const submit = handleSubmit(onSubmit)

    useEffect(() => {
        if (saveClientError) {
            setErrorMessage(saveClientError?.data?.message)
        }
    }, [saveClientError])

    const refresh = useCallback(() => {
        if (displayClient) {
            reset(displayClient)
        }
    }, [displayClient, reset])

    useEffect(() => {
        refresh()
    }, [refresh])

    const deleteClient = useCallback(() => {
        doDelete({PlannerClientKey: clientId})
        analyticsService.existingClientPressed('delete')
    }, [doDelete, clientId])

    return {
        submit,
        editMode,
        toggleEdit,
        errorMessage,
        deleteClient,
        displayClient,
        methods,
    }
}

export default useClientScreen
